import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const friendDetail = async (params: object) => {
  return await GET({ url: Api.friendDetail, params, showError: false })
}
